import { COMMON_NAMESPACE } from '@porsche-code/kado-i18n';
import { styled } from '@porsche-code/kado-styled-system/jsx';
import { Spacer } from '@porsche-code/kado-ui';
import NotAuthorizedIcon from '@porsche-code/kado-ui/icons/not-authorized.svg?react';
import {
  PButton,
  PHeading,
  PText,
} from '@porsche-design-system/components-react';
import { getCurrentUser } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Wrapper = styled('div', {
  base: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'xl',
  },
});

const Icon = styled(NotAuthorizedIcon, {
  base: {
    fontSize: '180px',
    my: 'xl',
    mx: 0,
  },
});

export const NotAuthorized = () => {
  const { t } = useTranslation(COMMON_NAMESPACE);

  const [isAnonymousButCouldBeCognito, setIsAnonymousButCouldBeCognito] =
    useState(false);

  useEffect(() => {
    let isMounted = true;
    const checkAuth = async () => {
      const authUser = await getCurrentUser().catch(() => null);
      if (isMounted) {
        setIsAnonymousButCouldBeCognito(
          Boolean(sessionStorage.getItem('authToken') && authUser),
        );
      }
    };
    checkAuth();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Wrapper>
      <PHeading tag="h3" size="xl">
        {t('notAuthorized.title')}
      </PHeading>
      <Icon />
      <PText>{t('notAuthorized.text')}</PText>
      {isAnonymousButCouldBeCognito && (
        <>
          <Spacer mb="md" />
          <PText>{t('notAuthorized.canExitAnonymousMode')}</PText>
          <Spacer mb="md" />
          <PButton
            onClick={() => {
              window.dispatchEvent(new Event('anonymousUserSignOut'));
            }}
          >
            {t('notAuthorized.exitAnonymousMode')}
          </PButton>
        </>
      )}
    </Wrapper>
  );
};
